"use client"

import { useEffect } from "react"
import { getThemeComponent } from "@/lib/theme-manager"
import { useApp } from "@/lib/context"
import { useTheme } from "@/lib/theme-context"
import { themes, type Theme } from "@/lib/themes"

interface ThemeRendererProps {
  isLoading?: boolean
  onLoadingComplete?: () => void
  showSwitcher?: boolean
}

export default function ThemeRenderer({ isLoading = false, onLoadingComplete }: ThemeRendererProps) {
  const { theme, setTheme } = useTheme()
  const { estabelecimento } = useApp()

  // Priority 1: Use estabelecimento.template (from backend) to drive the theme
  useEffect(() => {
    const template = estabelecimento?.template
    if (template && template in themes && template !== theme) {
      setTheme(template as Theme)
    }
  }, [estabelecimento?.template, theme, setTheme])

  // Obter o componente do tema (mantém compatibilidade com theme-manager)
  const ThemeComponent = getThemeComponent(theme)

  return (
    <>
      <ThemeComponent isLoading={isLoading} onLoadingComplete={onLoadingComplete} />
    </>
  )
}